import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import {
  AddressRequest,
  DataCollectionApi,
} from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

//for recovery, remove null / undefined field from object
function removeNullUndefinedWithReduce(obj: AddressRequest) {
  const newObj = Object.entries(obj).reduce<AddressRequest>(
    (acc, [key, value]) => {
      if (value !== null && value !== undefined) {
        acc[key as keyof AddressRequest] =
          typeof value === "object"
            ? removeNullUndefinedWithReduce(value)
            : value;
      }
      return acc;
    },
    {},
  );
  return Object.keys(newObj).length > 0 ? newObj : undefined;
}

export const submitAddress = createAsyncThunk<
  AddressRequest,
  AddressRequest,
  ThunkApi
>("submitAddress", async (args, { rejectWithValue }) => {
  try {
    const cleanedObject = removeNullUndefinedWithReduce(args);
    await new DataCollectionApi().addAddress(cleanedObject!);

    return args;
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Salvataggio indirizzo",
      description:
        "Non siamo riusciti a salvare il tuo indirizzo.\n Puoi riprovare o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
